import MoveToCofeeMobileField from './MoveToCofeeMobileField';
import QuickCollectFields from './QuickCollectFields';
import { QuickCollectFormData } from './types';

interface QuickCollectStepProps {
  leadName: string;
  formData: QuickCollectFormData;
  nameApiError?: string;
  onChange: (data: Partial<QuickCollectFormData>) => void;
}

const QuickCollectStep = ({
  leadName,
  formData,
  nameApiError,
  onChange
}: QuickCollectStepProps) => (
  <QuickCollectFields
    leadName={leadName}
    name={formData.name}
    branchId={formData.branchId}
    amount={formData.amount}
    notes={formData.notes}
    nameApiError={nameApiError}
    onNameChange={(val) => onChange({ name: val })}
    onBranchSelect={(value, label) =>
      onChange({ branchId: value, branchName: label })
    }
    onAmountChange={(val) => onChange({ amount: val })}
    onNotesChange={(val) => onChange({ notes: val })}
    afterName={
      <MoveToCofeeMobileField
        mobileNumber={formData.mobileNumber}
        countryCode={formData.countryCode}
        onChange={onChange}
      />
    }
  />
);

export default QuickCollectStep;
